import type { Country } from "@daytrip/legacy-models";

/**
 * Transforms an array of country IDs to a comma-separated string of country names
 * @param countryIds - Array of country IDs to transform
 * @param countries - Array of country objects with _id and englishName properties
 * @returns Comma-separated string of country names
 */
export function transformCountryIdsToNames(countryIds: string[], countries: Country[]): string {
    if (!countryIds || countryIds.length === 0) {
        return "";
    }

    if (!countries || countries.length === 0) {
        return "";
    }

    return countries
        .filter((country) => countryIds.includes(country._id))
        .map((country) => country.englishName)
        .sort((a, b) => a.localeCompare(b))
        .join(", ");
}

/**
 * Transforms an array of country IDs to a comma-separated string of country names using a Map
 * @param countryIds - Array of country IDs to transform
 * @param countryIdToNameMap - Map of country ID to country name
 * @returns Comma-separated string of country names
 */
export function transformCountryIdsToNamesWithMap(
    countryIds: string[],
    countryIdToNameMap: Map<string, string>,
): string {
    if (!countryIds || countryIds.length === 0) {
        return "";
    }

    if (!countryIdToNameMap) {
        return "";
    }

    return countryIds
        .map((id) => countryIdToNameMap.get(id))
        .filter(Boolean)
        .join(", ");
}
